import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import ReactMarkdown from "react-markdown";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/Shabu-Training-2021/ok.jpg";

const TrainingDetail = () => {
  const [training, setTraining] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const { trainingName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTraining = async () => {
      const { data, error } = await supabase
        .from("trainings")
        .select("*")
        .eq("training_name", trainingName)
        .single();
      if (error) {
        alert("Loading training please Be Patient, Press Ok to continue");
      } else {
        setTraining(data);
      }
      setLoading(false);
    };
    fetchTraining();
  }, [trainingName]);

  const handleDelete = async () => {
    const { error } = await supabase
      .from("trainings")
      .delete()
      .eq("training_name", trainingName);

    if (error) {
      alert("Error deleting training");
    } else {
      alert("Training deleted successfully");
      navigate("/services/trainings");
    }
  };

  const handleEdit = () => {
    navigate(`/services/trainings/edit/${trainingName}`);
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center"
        style={{ backgroundImage: `url(${bgIMG})` }}
      >
        <div className="absolute inset-0 bg-black opacity-60 z-0" />
        <div className="z-10">
          <TextEffect text1="Training Details" className="hero-title" />
        </div>
      </div>

      <div className="px-4 sm:px-[5%] py-12 max-w-5xl mx-auto space-y-6">
        <h2 className="text-3xl font-bold">{training?.title}</h2>
        <div className="prose">
          <ReactMarkdown>{training?.content}</ReactMarkdown>
        </div>
        <div className="space-x-4 mt-6">
          <button
            onClick={handleEdit}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
          >
            Edit Training
          </button>
          <button
            onClick={handleDelete}
            className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700"
          >
            Delete Training
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrainingDetail;
